import styled from "styled-components";
import { responsiveWidth } from "responsive";

export const MainSlider = styled.div<{
  target: string;
  isMobile: boolean;
  is80Value: boolean;
}>`
  box-shadow: ${({ target, isMobile }) =>
    target === "groupSale" && !isMobile
      ? "unset"
      : "0 4px 6px -2px rgba(0, 0, 0, 0.1)"};

  ${({ target, is80Value }) =>
    target !== "groupSale" &&
    `
     @media (min-width: 1921px) {
      height: ${is80Value ? "696px" : "577px"};
    }

    @media (min-width: 1351px) and (max-width: 1920px) {
      height: ${is80Value ? "620px" : "524px"};
    }

    @media (min-width: 1025px) and (max-width: 1350px) {
      height: ${is80Value ? "479px" : "401px"};
    }

    @media (min-width: 768px) and (max-width: 1024px) {
      height: ${is80Value ? "430px" : "370px"};
    }

    @media (min-width: 568px) and (max-width: 767px) {
      height: ${is80Value ? "1291px" : "1163px"};
    }

    @media (max-width: 567px) {
      height: ${is80Value ? "835px" : "762px"};
    }
  `}

  ${({ target }) =>
    target === "groupSale" &&
    `
 
  `}
`;

export const Container = styled.div<{ target: string }>`
  ${responsiveWidth}

  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;

  ${({ target }) =>
    target === "groupSale" &&
    ` padding: 0 !important;
    `}

  @media (min-width: 1921px) {
    padding-top: 84px;
    padding-bottom: 84px;

    .swiper {
      width: 100%;
      height: 100%;

      .prev {
        left: 0;

        &::after {
          display: none;
        }
      }

      .next {
        cursor: pointer;
        right: 0;

        &::after {
          display: none;
        }
      }

      .swiper-slide.cneter {
        margin-top: 100px;
      }

      .swiper-slide {
        display: flex;
        flex-direction: column;
        gap: 27px;

        .content {
          display: flex;
          flex-direction: row;
          justify-content: center;
          height: 409px;
          .left {
            position: relative;
            cursor: pointer;

            .img-wrapper {
              background: #f2f1f0;
              padding: 10px;
              border-radius: 16px;
              width: 415px;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;

              .img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                transition: transform 0.3s ease-in-out;

                &:hover {
                  transform: scale(1.05);
                }
              }

              .count-img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                position: relative;
                transition: transform 0.3s ease-in-out;

                &:hover {
                  transform: scale(1.05);
                }
              }
            }

            .countdown-salecoming {
              position: absolute;
              inset: 0;
              background-color: #0000005e;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              border-radius: 15px;

              .countdown-title {
                font-weight: 800;
                font-size: 24px;
                line-height: 100%;
                letter-spacing: -4%;
                text-align: center;
                color: #ffffff;
              }

              .countdown-subtitle {
                margin-top: 6px;
                font-weight: 700;
                font-size: 20px;
                line-height: 100%;
                letter-spacing: -4%;
                text-align: center;
                color: #ffffff;

                .time-event {
                  margin-top: 2px;
                  font-weight: 800;
                  font-size: 36px;
                }
              }
            }

            .count-num {
              position: absolute;
              bottom: 0px;
              width: 100%;
              height: 46px;
              border-bottom-right-radius: 16px;
              border-bottom-left-radius: 16px;
              background: #0000003d;
              font-weight: 800;
              font-size: 22px;
              line-height: 30px;
              letter-spacing: -0.05em;
              text-align: center;
              align-content: center;
              color: #ffffff;
            }
          }

          .right {
            margin-top: 7px;
            margin-left: 30px;
            width: 418px;

            .text {
              height: 166px;

              .type {
                font-weight: 800;
                font-size: 30px;
                line-height: 100%;
                letter-spacing: -0.05em;
              }

              .title {
                margin-top: 5px;
                font-weight: 700;
                line-height: 30px;
                letter-spacing: -0.05em;
                color: #5f5f5f;
                font-size: 20px;

                .small {
                  font-size: 16px;
                }
              }

              .description {
                margin-top: 7px;
                font-weight: 300;
                font-size: 14px;
                line-height: 20px;
                letter-spacing: -0.05em;
              }
            }

            .price {
              margin-top: 40px;
              color: #5f5f5f;
              height: 110px;
              display: flex;
              flex-direction: column;
              gap: 10px;

              .item {
                display: flex;
                flex-direction: row;
                gap: 15px;
                font-weight: 700;
                font-size: 18px;
                line-height: 100%;
                letter-spacing: -0.05em;

                .key {
                  font-weight: 800;
                }

                .value {
                  font-weight: 700;
                }

                .line {
                  font-weight: 100;
                  color: #424242;
                }
              }
            }

            .btn {
              margin-top: 40px;
              width: 418px;
              height: 46px;
              border-radius: 7px;
              gap: 10px;

              font-weight: 800;
              font-size: 14px;
              line-height: 100%;
              letter-spacing: -0.05em;
              text-align: center;
              align-content: center;
              color: #ffffff;
            }
          }
        }

        .bar80 {
          margin: 0 auto;
          width: 863px;
          height: 80px;
          background: #ffffffcc;

          .bar-wrapper {
            padding: 15px 20px;
            border: 1px solid #dadada;
            border-radius: 16px;
            height: 80px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .title {
              font-weight: 800;
              font-size: 18px;
              line-height: 31px;
              letter-spacing: -0.05em;
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              .left {
                span {
                  margin-left: 20px;
                  font-weight: 700;
                  line-height: 31px;
                }
              }

              .right {
                color: #653cd5;
              }
            }
          }
        }
      }
    }

    .image-popup {
      max-width: 100%;
      height: 741px;
    }
  }

  @media (min-width: 1351px) and (max-width: 1920px) {
    padding-top: 70px;
    padding-bottom: 70px;

    .swiper {
      width: 100%;
      height: 100%;

      .prev {
        cursor: pointer;
        left: 0;

        &::after {
          display: none;
        }
      }

      .next {
        cursor: pointer;
        right: 0;

        &::after {
          display: none;
        }
      }

      .swiper-slide {
        display: flex;
        flex-direction: column;
        gap: 20px;

        .content {
          display: flex;
          flex-direction: row;
          justify-content: center;
          height: 384px;

          .left {
            position: relative;
            cursor: pointer;

            .img-wrapper {
              background: #f2f1f0;
              padding: 10px;
              border-radius: 15px;
              width: 388px;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;

              .img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                transition: transform 0.3s ease-in-out;

                &:hover {
                  transform: scale(1.05);
                }
              }

              .count-img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                position: relative;
                transition: transform 0.3s ease-in-out;

                &:hover {
                  transform: scale(1.05);
                }
              }
            }

            .countdown-salecoming {
              position: absolute;
              inset: 0;
              background-color: #0000005e;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              border-radius: 14px;

              .countdown-title {
                font-weight: 800;
                font-size: 24px;
                line-height: 100%;
                letter-spacing: -4%;
                text-align: center;
                color: #ffffff;
              }

              .countdown-subtitle {
                margin-top: 6px;
                font-weight: 700;
                font-size: 20px;
                line-height: 100%;
                letter-spacing: -4%;
                text-align: center;
                color: #ffffff;

                .time-event {
                  margin-top: 2px;
                  font-weight: 800;
                  font-size: 36px;
                }
              }
            }

            .count-num {
              position: absolute;
              bottom: 0px;
              width: 100%;
              height: 43px;
              border-bottom-right-radius: 15px;
              border-bottom-left-radius: 15px;
              background: #0000003d;

              font-weight: 800;
              font-size: 20px;
              line-height: 30px;
              letter-spacing: -0.05em;
              text-align: center;
              align-content: center;
              color: #ffffff;
            }
          }

          .right {
            margin-top: 13px;
            margin-left: 30px;
            width: 392px;

            .text {
              height: 160px;

              .type {
                font-weight: 800;
                font-size: 28px;
                line-height: 100%;
                letter-spacing: -0.05em;
              }

              .title {
                margin-top: 10px;

                font-weight: 700;
                font-size: 18px;
                line-height: 24px;
                letter-spacing: -0.05em;
                color: #5f5f5f;

                .small {
                  font-size: 15px;
                }
              }

              .description {
                margin-top: 10px;

                font-weight: 300;
                font-size: 14px;
                line-height: 20px;
                letter-spacing: -0.05em;
              }
            }

            .price {
              margin-top: 34px;
              color: #5f5f5f;
              height: 100px;
              display: flex;
              flex-direction: column;
              gap: 12px;

              .item {
                display: flex;
                flex-direction: row;
                gap: 15px;

                font-size: 16px;
                line-height: 100%;
                letter-spacing: -0.05em;

                .key {
                  font-weight: 800;
                }

                .value {
                  font-weight: 700;
                }

                .line {
                  font-weight: 100;
                  color: #424242;
                }
              }
            }

            .btn {
              margin-top: 34px;
              width: 392px;
              height: 43px;
              border-radius: 6.56px;
              gap: 9px;
              background: #653cd5;

              font-weight: 800;
              font-size: 14px;
              line-height: 100%;
              letter-spacing: -0.05em;
              text-align: center;
              align-content: center;
              color: #ffffff;
              cursor: pointer;
            }
          }
        }

        .bar80 {
          margin: 0 auto;
          width: 810px;
          height: 76px;
          background: #ffffffcc;

          .bar-wrapper {
            padding: 15px 20px;
            border: 1px solid #dadada;
            border-radius: 14px;
            height: 76px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .title {
              font-weight: 800;
              font-size: 16px;
              letter-spacing: -0.05em;
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              .left {
                span {
                  margin-left: 16px;
                  font-weight: 700;
                }
              }

              .right {
                color: #653cd5;
              }
            }
          }
        }
      }
    }

    .image-popup {
      max-width: 100%;
      height: 620px;
    }
  }

  @media (min-width: 1025px) and (max-width: 1350px) {
    padding: 56px 0px;

    .swiper {
      width: 100%;
      height: 100%;

      .prev {
        cursor: pointer;
        left: 0;

        &::after {
          display: none;
        }
      }

      .next {
        cursor: pointer;
        right: 0;

        &::after {
          display: none;
        }
      }

      .swiper-slide {
        display: flex;
        flex-direction: column;
        gap: 18px;

        .content {
          display: flex;
          flex-direction: row;
          justify-content: center;
          height: 289px;

          .left {
            position: relative;
            cursor: pointer;

            .img-wrapper {
              background: #f2f1f0;
              padding: 10px;
              border-radius: 16px;
              width: 292px;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;

              .img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                transition: transform 0.3s ease-in-out;

                &:hover {
                  transform: scale(1.05);
                }
              }

              .count-img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                position: relative;
                transition: transform 0.3s ease-in-out;

                &:hover {
                  transform: scale(1.05);
                }
              }
            }

            .countdown-salecoming {
              position: absolute;
              inset: 0;
              background-color: #0000005e;
              display: flex;
              align-items: center;
              text-align: center;
              justify-content: center;
              flex-direction: column;
              border-radius: 15px;
              letter-spacing: -4%;
              line-height: 100%;
              color: #ffffff;

              .countdown-title {
                font-weight: 800;
                font-size: 20px;
              }

              .countdown-subtitle {
                margin-top: 10px;
                font-weight: 700;
                font-size: 16px;

                .time-event {
                  margin-top: 2px;
                  font-weight: 800;
                  font-size: 32px;
                }
              }
            }

            .count-num {
              position: absolute;
              bottom: 0px;
              width: 100%;
              height: 33px;
              border-bottom-right-radius: 11px;
              border-bottom-left-radius: 11px;
              background: #0000003d;
              font-weight: 800;
              font-size: 14px;
              line-height: 30px;
              letter-spacing: -0.05em;
              text-align: center;
              align-content: center;
              color: #ffffff;
            }
          }

          .right {
            margin-top: 9px;
            margin-left: 22px;
            width: 295px;

            .text {
              height: 124px;

              .type {
                font-weight: 800;
                font-size: 22px;
                line-height: 100%;
                letter-spacing: -0.05em;
              }

              .title {
                margin-top: 8px;
                font-weight: 700;
                font-size: 16px;
                line-height: 20px;
                letter-spacing: -0.05em;
                color: #5f5f5f;

                .small {
                  font-size: 14px;
                }
              }

              .description {
                margin-top: 3px;
                font-weight: 300;
                font-size: 12px;
                line-height: 16px;
                letter-spacing: -0.05em;
              }
            }

            .price {
              margin-top: 24px;
              color: #5f5f5f;
              height: 75px;
              display: flex;
              flex-direction: column;
              gap: 10px;

              .item {
                display: flex;
                flex-direction: row;
                gap: 15px;

                font-size: 12px;
                line-height: 8.47px;
                letter-spacing: -0.05em;

                .key {
                  font-weight: 800;
                }

                .value {
                  font-weight: 700;
                }

                .line {
                  font-weight: 100;
                  color: #424242;
                }
              }
            }

            .btn {
              margin-top: 24px;
              width: 295px;
              height: 33px;
              border-radius: 4.94px;
              gap: 7px;
              background: #653cd5;

              font-weight: 800;
              font-size: 12px;
              line-height: 100%;
              letter-spacing: -0.05em;
              text-align: center;
              align-content: center;
              color: #ffffff;
              cursor: pointer;
            }
          }
        }

        .bar80 {
          margin: 0 auto;
          width: 609px;
          height: 60px;
          background: #ffffffcc;

          .bar-wrapper {
            padding: 15px 20px;
            border: 1px solid #dadada;
            border-radius: 12px;
            height: 60px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .title {
              font-weight: 800;
              font-size: 14px;
              line-height: 100%;
              letter-spacing: -0.05em;
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              .left {
                span {
                  margin-left: 16px;
                  font-weight: 700;
                }
              }

              .right {
                color: #653cd5;
              }
            }
          }
        }
      }
    }

    .image-popup {
      max-width: 100%;
      height: 620px;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    padding-top: 55px;
    padding-bottom: 55px;

    .swiper {
      width: 100%;
      height: 100%;

      .prev {
        cursor: pointer;
        left: 0;

        &::after {
          display: none;
        }
      }

      .next {
        cursor: pointer;
        right: 0;

        &::after {
          display: none;
        }
      }

      .swiper-slide {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .content {
          display: flex;
          flex-direction: row;
          justify-content: center;
          height: 260px;

          .left {
            position: relative;
            cursor: pointer;

            .img-wrapper {
              background: #f2f1f0;
              padding: 10px;
              border-radius: 16px;
              width: 263px;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;

              .img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                transition: transform 0.3s ease-in-out;

                &:hover {
                  transform: scale(1.05);
                }
              }

              .count-img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                position: relative;
                transition: transform 0.3s ease-in-out;

                &:hover {
                  transform: scale(1.05);
                }
              }
            }

            .countdown-salecoming {
              position: absolute;
              inset: 0;
              background-color: #0000005e;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              border-radius: 9px;

              .countdown-title {
                font-weight: 800;
                font-size: 16px;
                line-height: 100%;
                letter-spacing: -4%;
                text-align: center;
                color: #ffffff;
              }

              .countdown-subtitle {
                margin-top: 6px;
                font-weight: 700;
                font-size: 12px;
                line-height: 100%;
                letter-spacing: -4%;
                text-align: center;
                color: #ffffff;

                .time-event {
                  margin-top: 2px;
                  font-weight: 800;
                  font-size: 26px;
                }
              }
            }

            .count-num {
              position: absolute;
              bottom: 0px;
              width: 100%;
              height: 29px;
              border-bottom-right-radius: 11px;
              border-bottom-left-radius: 11px;
              background: #0000003d;
              font-weight: 800;
              font-size: 14px;
              line-height: 100%;
              letter-spacing: -0.05em;
              text-align: center;
              align-content: center;
              color: #ffffff;
            }
          }

          .right {
            margin-top: 13px;
            margin-left: 22px;
            width: 267px;

            .text {
              height: 116px;

              .type {
                font-weight: 800;
                font-size: 20px;
                line-height: 100%;
                letter-spacing: -0.05em;
              }

              .title {
                margin-top: 5px;
                font-weight: 700;
                font-size: 14px;
                line-height: 20px;
                letter-spacing: -0.05em;
                color: #5f5f5f;

                .small {
                  font-size: 12px;
                }
              }

              .description {
                margin-top: 6px;
                font-weight: 300;
                font-size: 10px;
                line-height: 14px;
                letter-spacing: -0.05em;
              }
            }

            .price {
              margin-top: 14px;
              color: #5f5f5f;
              height: 74px;
              display: flex;
              flex-direction: column;
              gap: 6px;

              .item {
                display: flex;
                flex-direction: row;
                gap: 15px;

                font-size: 12px;
                line-height: 100%;
                letter-spacing: -0.05em;

                .key {
                  font-weight: 800;
                }

                .value {
                  font-weight: 700;
                }

                .line {
                  font-weight: 100;
                  color: #424242;
                }
              }
            }

            .btn {
              margin-top: 14px;
              width: 267px;
              height: 29px;
              border-radius: 4.46px;
              gap: 6.37px;
              background: #653cd5;

              font-weight: 800;
              font-size: 10px;
              leading-trim: Cap height;
              line-height: 100%;
              letter-spacing: -0.05em;
              text-align: center;
              align-content: center;
              color: #ffffff;
              cursor: pointer;
            }
          }
        }

        .bar80 {
          margin: 0 auto;
          width: 552px;
          height: 54px;
          background: #ffffffcc;

          .bar-wrapper {
            padding: 13px 20px;
            border: 1px solid #dadada;
            border-radius: 12px;
            height: 54px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .title {
              font-weight: 800;
              font-size: 12px;
              line-height: 100%;
              letter-spacing: -0.05em;
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              .left {
                span {
                  margin-left: 27px;
                  font-weight: 700;
                }
              }

              .right {
                color: #653cd5;
              }
            }
          }
        }
      }
    }
  }

  @media (min-width: 568px) and (max-width: 767px) {
    padding: 100px 25px !important;
    height: 100%;

    .swiper {
      width: 100%;
      height: 100%;

      .swiper-slide {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .text {
          height: 109px;

          .type {
            font-weight: 800;
            font-size: 34px;
            line-height: 100%;
            letter-spacing: -0.05em;
            text-align: center;
          }

          .title {
            margin-top: 12px;
            font-weight: 700;
            font-size: 22px;
            line-height: 29px;
            letter-spacing: -0.05em;
            text-align: center;
            color: #5f5f5f;
          }
        }

        .left {
          position: relative;
          cursor: pointer;
          margin-top: 34px;
          display: flex;
          justify-content: center;
          align-items: center;

          .img-wrapper {
            border-radius: 22px;
            background: #f2f1f0;
            width: 516px;
            height: 509px;

            .img {
              width: 516px;
              height: 509px;
              border-radius: 22px;
              object-fit: contain;
              transition: transform 0.3s ease-in-out;
              padding: 10px;

              &:hover {
                transform: scale(1.05);
              }
            }

            .count-img {
              width: 100%;
              height: 509px;
              object-fit: contain;
              position: relative;
              transition: transform 0.3s ease-in-out;
              padding: 15px;

              &:hover {
                transform: scale(1.05);
              }
            }
          }

          .countdown-salecoming {
            position: absolute;
            inset: 0;
            background-color: #0000005e;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            border-radius: 15px;

            .countdown-title {
              font-weight: 800;
              font-size: 24px;
              line-height: 100%;
              letter-spacing: -4%;
              text-align: center;
              color: #ffffff;
            }

            .countdown-subtitle {
              margin-top: 6px;

              font-weight: 700;
              font-size: 20px;
              line-height: 100%;
              letter-spacing: -4%;
              text-align: center;
              color: #ffffff;

              .time-event {
                margin-top: 2px;
                font-weight: 800;
                font-size: 36px;
              }
            }
          }

          .count-num {
            position: absolute;
            bottom: 0px;
            width: 516px;
            height: 56px;
            border-bottom-right-radius: 16px;
            border-bottom-left-radius: 16px;
            background: #0000003d;

            font-weight: 800;
            font-size: 22px;
            line-height: 30px;
            letter-spacing: -0.05em;
            text-align: center;
            align-content: center;
            color: #ffffff;
          }
        }

        .price {
          margin-top: 34px;
          display: grid;
          grid-template-columns: 1fr 2fr;
          grid-template-rows: repeat(2, auto);
          gap: 10px;
          height: 140px;
          align-self: center;
          width: 516px;

          .item {
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding: 0 26px;
            .key {
              text-align: left;

              font-weight: 800;
              font-size: 22px;
              line-height: 25px;
              letter-spacing: -0.05em;
              color: #a9a9a9;
            }

            .value {
              text-align: left;

              font-weight: 800;
              font-size: 22px;
              line-height: 25px;
              letter-spacing: -0.05em;
            }
          }
        }

        .btn {
          margin-top: 26px;
          width: 516px;
          height: 58px;
          gap: 14px;
          border-radius: 10px;
          background: #653cd5;

          font-weight: 800;
          font-size: 22px;
          line-height: 100%;
          letter-spacing: -0.05em;
          text-align: center;
          align-content: center;
          color: #ffffff;
          cursor: pointer;
          align-self: center;
        }

        .bar80 {
          margin: 0 auto;
          width: 516px;
          height: 98px;
          background: #ffffffcc;
          margin-top: 34px;

          .bar-wrapper {
            padding: 25px 26px;
            border: 1px solid #dadada;
            border-radius: 16px;
            height: 98px;
            display: flex;
            flex-direction: column;
            gap: 17px;

            .title {
              font-weight: 700;
              font-size: 20px;
              line-height: 100%;
              letter-spacing: -0.05em;
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              .left {
                margin-top: unset;
                span {
                  margin-left: 21px;
                  font-weight: 800;
                }
              }

              .right {
                color: #653cd5;
              }
            }
          }
        }
      }
    }

    .swiper-pagination {
      margin-top: 34px;
      bottom: 0px !important;

      .swiper-pagination-bullet-active {
        background: #653cd5 !important;
        color: #653cd5;
      }

      .swiper-pagination-bullet {
        background: #b9b9b9;
      }
    }
  }

  @media (max-width: 567px) {
    padding: 60px 15px !important;
    height: 100%;

    .swiper {
      width: 325px;
      height: 100%;

      @media (max-width: 362px) {
        width: 100%;
      }

      .swiper-slide {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .text {
          height: 75px;

          .type {
            font-weight: 800;
            font-size: 22px;
            line-height: 100%;
            letter-spacing: -0.05em;
            text-align: center;
          }

          .title {
            margin-top: 10px;
            font-weight: 700;
            font-size: 14px;
            line-height: 20px;
            letter-spacing: -0.05em;
            text-align: center;
            color: #5f5f5f;
          }
        }

        .left {
          position: relative;
          cursor: pointer;
          margin-top: 24px;
          display: flex;
          justify-content: center;
          align-items: center;

          .img-wrapper {
            border-radius: 14px;
            background: #f2f1f0;
            width: 325px;
            height: 320px;

            @media (max-width: 362px) {
              width: 100%;
            }

            .img {
              width: 325px;
              height: 100%;
              border-radius: 14px;
              object-fit: contain;
              transition: transform 0.3s ease-in-out;
              padding: 10px;

              @media (max-width: 362px) {
                width: 100%;
              }

              &:hover {
                transform: scale(1.05);
              }
            }

            .count-img {
              width: 325px;
              height: 100%;
              object-fit: contain;
              position: relative;
              transition: transform 0.3s ease-in-out;
              padding: 10px;

              @media (max-width: 362px) {
                width: 100%;
              }

              &:hover {
                transform: scale(1.05);
              }
            }
          }

          .countdown-salecoming {
            position: absolute;
            inset: 0;
            background-color: #0000005e;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            border-radius: 14px;

            .countdown-title {
              font-weight: 800;
              font-size: 22px;
              line-height: 100%;
              letter-spacing: -4%;
              text-align: center;
              color: #ffffff;
            }

            .countdown-subtitle {
              margin-top: 6px;
              font-weight: 700;
              font-size: 18px;
              line-height: 100%;
              letter-spacing: -4%;
              text-align: center;
              color: #ffffff;

              .time-event {
                margin-top: 2px;
                font-weight: 800;
                font-size: 34px;
              }
            }
          }

          .count-num {
            position: absolute;
            bottom: 0px;
            width: 325px;
            height: 36px;
            border-bottom-right-radius: 14px;
            border-bottom-left-radius: 14px;
            background: #0000003d;

            @media (max-width: 326px) {
              width: 100%;
            }

            font-weight: 800;
            font-size: 16px;
            line-height: 30px;
            letter-spacing: -0.05em;
            text-align: center;
            color: #ffffff;
          }
        }

        .price {
          margin-top: 24px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-template-rows: repeat(2, auto);
          gap: 27px 15px;
          height: 98px;
          align-self: center;

          .item {
            display: flex;
            flex-direction: column;
            gap: 5px;

            .key {
              text-align: left;
              font-weight: 800;
              font-size: 14px;
              line-height: 100%;
              letter-spacing: -0.05em;
              color: #a9a9a9;
            }

            .value {
              text-align: left;

              font-weight: 800;
              font-size: 14px;
              line-height: 100%;
              letter-spacing: -0.05em;
            }
          }
        }

        .btn {
          margin: 24px 0px;
          width: 325px;
          height: 36px;
          gap: 14px;
          border-radius: 6px;
          background: #653cd5;

          @media (max-width: 362px) {
            width: 100%;
          }

          font-weight: 800;
          font-size: 14px;
          line-height: 100%;
          letter-spacing: -0.05em;
          text-align: center;
          align-content: center;
          color: #ffffff;
          cursor: pointer;
          align-self: center;
        }

        .bar80 {
          margin: 0 auto;
          width: 325px;
          height: 62px;
          background: #ffffffcc;
          margin-top: 20px;

          @media (max-width: 362px) {
            width: 100%;
          }

          .bar-wrapper {
            padding: 15px 14px;
            border: 1px solid #dadada;
            border-radius: 8px;
            height: 62px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .title {
              font-weight: 700;
              font-size: 14px;
              line-height: 100%;
              letter-spacing: -0.05em;
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              .left {
                margin-top: unset;
                span {
                  margin-left: 12px;
                  font-weight: 800;
                }
              }

              .right {
                color: #653cd5;
              }
            }
          }
        }
      }
    }

    .swiper-pagination {
      margin-top: 24px;
      bottom: 0px !important;

      .swiper-pagination-bullet-active {
        background: #653cd5 !important;
        color: #653cd5;
      }

      .swiper-pagination-bullet {
        background: #b9b9b9;
      }
    }
  }
`;
export const Content = styled.div``;
